export default __webpack_public_path__ + "static/retail-fading-fd1a2c309f1d8eb5ccf540de53a26fa7.gif";